import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'DialogDeleteConfirm',
  props: {
    title: { default: '' }
  },
  emits: ["confirmed"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

const confimDialog = ref(false)

const onDelete = () => {
  emit('confirmed')
  confimDialog.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: confimDialog.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((confimDialog).value = $event)),
    width: "500",
    "retain-focus": false
  }, {
    activator: _withCtx(({ props }) => [
      _createVNode(_component_v_btn, _mergeProps({ icon: "" }, props, {
        size: "x-small",
        class: "ms-2",
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
      }), {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, null, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("mdi-delete", -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 16 /* FULL_PROPS */)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "headline bg-grey-lighten-2" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.title), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                color: "primary",
                text: "",
                onClick: onDelete
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode(" 削除 ", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue"]))
}
}

})